/* Updated: 2026-06-18 03:00 UTC+1 — Hub contact form location data */

(function () {
  if (window.GOHUB_CONTACT_LOCATION) return;

  var COUNTRIES = [
    { c: 'AF', n: 'Afghanistan' }, { c: 'AL', n: 'Albania' }, { c: 'DZ', n: 'Algeria' }, { c: 'AD', n: 'Andorra' },
    { c: 'AO', n: 'Angola' }, { c: 'AG', n: 'Antigua and Barbuda' }, { c: 'AR', n: 'Argentina' }, { c: 'AM', n: 'Armenia' },
    { c: 'AU', n: 'Australia' }, { c: 'AT', n: 'Austria' }, { c: 'AZ', n: 'Azerbaijan' }, { c: 'BS', n: 'Bahamas' },
    { c: 'BH', n: 'Bahrain' }, { c: 'BD', n: 'Bangladesh' }, { c: 'BB', n: 'Barbados' }, { c: 'BY', n: 'Belarus' },
    { c: 'BE', n: 'Belgium' }, { c: 'BZ', n: 'Belize' }, { c: 'BJ', n: 'Benin' }, { c: 'BM', n: 'Bermuda' },
    { c: 'BT', n: 'Bhutan' }, { c: 'BO', n: 'Bolivia' }, { c: 'BA', n: 'Bosnia and Herzegovina' },
    { c: 'BW', n: 'Botswana' }, { c: 'BR', n: 'Brazil' }, { c: 'BN', n: 'Brunei' }, { c: 'BG', n: 'Bulgaria' },
    { c: 'BF', n: 'Burkina Faso' }, { c: 'BI', n: 'Burundi' }, { c: 'CV', n: 'Cape Verde' }, { c: 'KH', n: 'Cambodia' },
    { c: 'CM', n: 'Cameroon' }, { c: 'CA', n: 'Canada' }, { c: 'KY', n: 'Cayman Islands' },
    { c: 'CF', n: 'Central African Republic' }, { c: 'TD', n: 'Chad' }, { c: 'CL', n: 'Chile' }, { c: 'CN', n: 'China' },
    { c: 'CO', n: 'Colombia' }, { c: 'KM', n: 'Comoros' }, { c: 'CG', n: 'Congo' }, { c: 'CD', n: 'DR Congo' },
    { c: 'CR', n: 'Costa Rica' }, { c: 'CI', n: "Côte d'Ivoire" }, { c: 'HR', n: 'Croatia' }, { c: 'CU', n: 'Cuba' },
    { c: 'CY', n: 'Cyprus' }, { c: 'CZ', n: 'Czech Republic' }, { c: 'DK', n: 'Denmark' }, { c: 'DJ', n: 'Djibouti' },
    { c: 'DM', n: 'Dominica' }, { c: 'DO', n: 'Dominican Republic' }, { c: 'EC', n: 'Ecuador' }, { c: 'EG', n: 'Egypt' },
    { c: 'SV', n: 'El Salvador' }, { c: 'GQ', n: 'Equatorial Guinea' }, { c: 'ER', n: 'Eritrea' }, { c: 'EE', n: 'Estonia' },
    { c: 'SZ', n: 'Eswatini' }, { c: 'ET', n: 'Ethiopia' }, { c: 'FJ', n: 'Fiji' }, { c: 'FI', n: 'Finland' },
    { c: 'FR', n: 'France' }, { c: 'GA', n: 'Gabon' }, { c: 'GM', n: 'Gambia' }, { c: 'GE', n: 'Georgia' },
    { c: 'DE', n: 'Germany' }, { c: 'GH', n: 'Ghana' }, { c: 'GR', n: 'Greece' }, { c: 'GD', n: 'Grenada' },
    { c: 'GT', n: 'Guatemala' }, { c: 'GN', n: 'Guinea' }, { c: 'GW', n: 'Guinea-Bissau' }, { c: 'GY', n: 'Guyana' },
    { c: 'HT', n: 'Haiti' }, { c: 'HN', n: 'Honduras' }, { c: 'HK', n: 'Hong Kong' }, { c: 'HU', n: 'Hungary' },
    { c: 'IS', n: 'Iceland' }, { c: 'IN', n: 'India' }, { c: 'ID', n: 'Indonesia' }, { c: 'IR', n: 'Iran' },
    { c: 'IQ', n: 'Iraq' }, { c: 'IE', n: 'Ireland' }, { c: 'IL', n: 'Israel' }, { c: 'IT', n: 'Italy' },
    { c: 'JM', n: 'Jamaica' }, { c: 'JP', n: 'Japan' }, { c: 'JO', n: 'Jordan' }, { c: 'KZ', n: 'Kazakhstan' },
    { c: 'KE', n: 'Kenya' }, { c: 'KI', n: 'Kiribati' }, { c: 'KP', n: 'North Korea' }, { c: 'KR', n: 'South Korea' },
    { c: 'KW', n: 'Kuwait' }, { c: 'KG', n: 'Kyrgyzstan' }, { c: 'LA', n: 'Laos' }, { c: 'LV', n: 'Latvia' },
    { c: 'LB', n: 'Lebanon' }, { c: 'LS', n: 'Lesotho' }, { c: 'LR', n: 'Liberia' }, { c: 'LY', n: 'Libya' },
    { c: 'LI', n: 'Liechtenstein' }, { c: 'LT', n: 'Lithuania' }, { c: 'LU', n: 'Luxembourg' }, { c: 'MO', n: 'Macau' },
    { c: 'MG', n: 'Madagascar' }, { c: 'MW', n: 'Malawi' }, { c: 'MY', n: 'Malaysia' }, { c: 'MV', n: 'Maldives' },
    { c: 'ML', n: 'Mali' }, { c: 'MT', n: 'Malta' }, { c: 'MH', n: 'Marshall Islands' }, { c: 'MR', n: 'Mauritania' },
    { c: 'MU', n: 'Mauritius' }, { c: 'MX', n: 'Mexico' }, { c: 'FM', n: 'Micronesia' }, { c: 'MD', n: 'Moldova' },
    { c: 'MC', n: 'Monaco' }, { c: 'MN', n: 'Mongolia' }, { c: 'ME', n: 'Montenegro' }, { c: 'MA', n: 'Morocco' },
    { c: 'MZ', n: 'Mozambique' }, { c: 'MM', n: 'Myanmar' }, { c: 'NA', n: 'Namibia' }, { c: 'NR', n: 'Nauru' },
    { c: 'NP', n: 'Nepal' }, { c: 'NL', n: 'Netherlands' }, { c: 'NZ', n: 'New Zealand' }, { c: 'NI', n: 'Nicaragua' },
    { c: 'NE', n: 'Niger' }, { c: 'NG', n: 'Nigeria' }, { c: 'MK', n: 'North Macedonia' }, { c: 'NO', n: 'Norway' },
    { c: 'OM', n: 'Oman' }, { c: 'PK', n: 'Pakistan' }, { c: 'PW', n: 'Palau' }, { c: 'PS', n: 'Palestine' },
    { c: 'PA', n: 'Panama' }, { c: 'PG', n: 'Papua New Guinea' }, { c: 'PY', n: 'Paraguay' }, { c: 'PE', n: 'Peru' },
    { c: 'PH', n: 'Philippines' }, { c: 'PL', n: 'Poland' }, { c: 'PT', n: 'Portugal' }, { c: 'QA', n: 'Qatar' },
    { c: 'RO', n: 'Romania' }, { c: 'RU', n: 'Russia' }, { c: 'RW', n: 'Rwanda' }, { c: 'KN', n: 'Saint Kitts and Nevis' },
    { c: 'LC', n: 'Saint Lucia' }, { c: 'VC', n: 'Saint Vincent' }, { c: 'WS', n: 'Samoa' },
    { c: 'SM', n: 'San Marino' }, { c: 'ST', n: 'São Tomé and Príncipe' }, { c: 'SA', n: 'Saudi Arabia' },
    { c: 'SN', n: 'Senegal' }, { c: 'RS', n: 'Serbia' }, { c: 'SC', n: 'Seychelles' }, { c: 'SL', n: 'Sierra Leone' },
    { c: 'SG', n: 'Singapore' }, { c: 'SK', n: 'Slovakia' }, { c: 'SI', n: 'Slovenia' }, { c: 'SB', n: 'Solomon Islands' },
    { c: 'SO', n: 'Somalia' }, { c: 'ZA', n: 'South Africa' }, { c: 'SS', n: 'South Sudan' }, { c: 'ES', n: 'Spain' },
    { c: 'LK', n: 'Sri Lanka' }, { c: 'SD', n: 'Sudan' }, { c: 'SR', n: 'Suriname' }, { c: 'SE', n: 'Sweden' },
    { c: 'CH', n: 'Switzerland' }, { c: 'SY', n: 'Syria' }, { c: 'TW', n: 'Taiwan' }, { c: 'TJ', n: 'Tajikistan' },
    { c: 'TZ', n: 'Tanzania' }, { c: 'TH', n: 'Thailand' }, { c: 'TL', n: 'Timor-Leste' }, { c: 'TG', n: 'Togo' },
    { c: 'TO', n: 'Tonga' }, { c: 'TT', n: 'Trinidad and Tobago' }, { c: 'TN', n: 'Tunisia' }, { c: 'TR', n: 'Turkey' },
    { c: 'TV', n: 'Tuvalu' }, { c: 'UG', n: 'Uganda' }, { c: 'UA', n: 'Ukraine' }, { c: 'AE', n: 'United Arab Emirates' },
    { c: 'GB', n: 'United Kingdom' }, { c: 'US', n: 'United States' }, { c: 'UY', n: 'Uruguay' },
    { c: 'UZ', n: 'Uzbekistan' }, { c: 'VU', n: 'Vanuatu' }, { c: 'VA', n: 'Vatican City' }, { c: 'VE', n: 'Venezuela' },
    { c: 'VN', n: 'Vietnam' }, { c: 'YE', n: 'Yemen' }, { c: 'ZM', n: 'Zambia' }, { c: 'ZW', n: 'Zimbabwe' }
  ];

  var US_STATES = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
    'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
    'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
    'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
    'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  var US_CITIES_BY_STATE = {
    Alabama: ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'],
    Alaska: ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka', 'Ketchikan'],
    Arizona: ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale', 'Tempe', 'Chandler', 'Glendale', 'Flagstaff'],
    Arkansas: ['Little Rock', 'Fayetteville', 'Fort Smith', 'Springdale', 'Bentonville'],
    California: ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento', 'Oakland', 'Hollywood', 'Fresno', 'Long Beach', 'Anaheim', 'Santa Monica', 'Berkeley', 'Pasadena', 'Irvine', 'Beverly Hills', 'Santa Barbara', 'Riverside', 'Stockton', 'Bakersfield', 'Palo Alto'],
    Colorado: ['Denver', 'Colorado Springs', 'Aurora', 'Boulder', 'Fort Collins', 'Aspen'],
    Connecticut: ['Hartford', 'New Haven', 'Stamford', 'Bridgeport', 'Greenwich'],
    Delaware: ['Wilmington', 'Dover', 'Newark', 'Rehoboth Beach'],
    'District of Columbia': ['Washington'],
    Florida: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Tallahassee', 'Naples', 'Sarasota', 'Key West', 'West Palm Beach'],
    Georgia: ['Atlanta', 'Savannah', 'Augusta', 'Columbus', 'Athens', 'Macon'],
    Hawaii: ['Honolulu', 'Hilo', 'Kailua', 'Lahaina', 'Kihei'],
    Idaho: ['Boise', 'Idaho Falls', 'Nampa', 'Coeur d\'Alene', 'Sun Valley'],
    Illinois: ['Chicago', 'Springfield', 'Naperville', 'Aurora', 'Rockford', 'Peoria', 'Evanston'],
    Indiana: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Bloomington'],
    Iowa: ['Des Moines', 'Cedar Rapids', 'Davenport', 'Iowa City', 'Sioux City'],
    Kansas: ['Wichita', 'Kansas City', 'Topeka', 'Overland Park', 'Lawrence'],
    Kentucky: ['Louisville', 'Lexington', 'Bowling Green', 'Frankfort', 'Covington'],
    Louisiana: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'],
    Maine: ['Portland', 'Bangor', 'Augusta', 'Bar Harbor', 'Kennebunkport'],
    Maryland: ['Baltimore', 'Annapolis', 'Frederick', 'Rockville', 'Bethesda', 'Ocean City'],
    Massachusetts: ['Boston', 'Cambridge', 'Worcester', 'Springfield', 'Salem', 'Plymouth', 'Cape Cod'],
    Michigan: ['Detroit', 'Grand Rapids', 'Ann Arbor', 'Lansing', 'Flint', 'Traverse City'],
    Minnesota: ['Minneapolis', 'Saint Paul', 'Rochester', 'Duluth', 'Bloomington'],
    Mississippi: ['Jackson', 'Biloxi', 'Gulfport', 'Hattiesburg', 'Oxford'],
    Missouri: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Branson'],
    Montana: ['Billings', 'Missoula', 'Bozeman', 'Helena', 'Great Falls'],
    Nebraska: ['Omaha', 'Lincoln', 'Grand Island', 'Kearney', 'Scottsbluff'],
    Nevada: ['Las Vegas', 'Reno', 'Henderson', 'Carson City', 'Lake Tahoe'],
    'New Hampshire': ['Manchester', 'Nashua', 'Concord', 'Portsmouth', 'Hanover'],
    'New Jersey': ['Newark', 'Jersey City', 'Trenton', 'Atlantic City', 'Princeton', 'Hoboken'],
    'New Mexico': ['Albuquerque', 'Santa Fe', 'Las Cruces', 'Taos', 'Roswell'],
    'New York': ['New York City', 'Buffalo', 'Rochester', 'Albany', 'Syracuse', 'Brooklyn', 'Manhattan', 'Queens', 'Bronx', 'Staten Island', 'Ithaca', 'Niagara Falls'],
    'North Carolina': ['Charlotte', 'Raleigh', 'Durham', 'Asheville', 'Wilmington', 'Greensboro'],
    'North Dakota': ['Fargo', 'Bismarck', 'Grand Forks', 'Minot', 'Williston'],
    Ohio: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton'],
    Oklahoma: ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Stillwater'],
    Oregon: ['Portland', 'Salem', 'Eugene', 'Bend', 'Medford', 'Ashland'],
    Pennsylvania: ['Philadelphia', 'Pittsburgh', 'Harrisburg', 'Allentown', 'Erie', 'Lancaster', 'Gettysburg'],
    'Rhode Island': ['Providence', 'Newport', 'Warwick', 'Cranston'],
    'South Carolina': ['Charleston', 'Columbia', 'Greenville', 'Myrtle Beach', 'Hilton Head'],
    'South Dakota': ['Sioux Falls', 'Rapid City', 'Pierre', 'Aberdeen', 'Deadwood'],
    Tennessee: ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Gatlinburg'],
    Texas: ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Plano', 'Arlington', 'Galveston', 'Lubbock'],
    Utah: ['Salt Lake City', 'Provo', 'Park City', 'Ogden', 'St. George'],
    Vermont: ['Burlington', 'Montpelier', 'Rutland', 'Stowe', 'Brattleboro'],
    Virginia: ['Virginia Beach', 'Norfolk', 'Richmond', 'Arlington', 'Alexandria', 'Charlottesville', 'Williamsburg'],
    Washington: ['Seattle', 'Spokane', 'Tacoma', 'Bellevue', 'Olympia', 'Bellingham'],
    'West Virginia': ['Charleston', 'Morgantown', 'Huntington', 'Wheeling', 'Harper\'s Ferry'],
    Wisconsin: ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Appleton'],
    Wyoming: ['Cheyenne', 'Casper', 'Jackson', 'Laramie', 'Cody']
  };

  var CITIES = {
    GB: ['London', 'Birmingham', 'Manchester', 'Glasgow', 'Liverpool', 'Leeds', 'Sheffield', 'Edinburgh', 'Bristol', 'Cardiff', 'Belfast', 'Newcastle', 'Nottingham', 'Southampton', 'Leicester', 'Coventry', 'Brighton', 'Plymouth', 'Reading', 'Aberdeen', 'Derby', 'York', 'Oxford', 'Cambridge', 'Bournemouth', 'Swansea', 'Exeter', 'Norwich', 'Hull', 'Stoke-on-Trent', 'Milton Keynes', 'Northampton', 'Luton', 'Portsmouth', 'Sunderland', 'Wolverhampton', 'Dundee', 'Inverness', 'Stirling'],
    IE: ['Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford', 'Drogheda', 'Kilkenny', 'Sligo', 'Wexford', 'Athlone'],
    AU: ['Sydney', 'Melbourne', 'Brisbane', 'Perth', 'Adelaide', 'Gold Coast', 'Canberra', 'Newcastle', 'Hobart', 'Darwin', 'Wollongong', 'Geelong', 'Townsville', 'Cairns', 'Toowoomba', 'Ballarat', 'Bendigo', 'Launceston'],
    NZ: ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga', 'Dunedin', 'Queenstown', 'Napier', 'Palmerston North'],
    CA: ['Toronto', 'Montreal', 'Vancouver', 'Calgary', 'Edmonton', 'Ottawa', 'Winnipeg', 'Quebec City', 'Hamilton', 'Kitchener', 'London', 'Victoria', 'Halifax', 'Saskatoon', 'Regina', 'St. John\'s', 'Mississauga', 'Brampton', 'Surrey', 'Laval'],
    DE: ['Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Bremen', 'Dresden', 'Hanover', 'Nuremberg', 'Bonn', 'Heidelberg', 'Freiburg'],
    FR: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Grenoble', 'Dijon', 'Tours', 'Avignon', 'Cannes'],
    ES: ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Zaragoza', 'Málaga', 'Murcia', 'Palma', 'Bilbao', 'Alicante', 'Córdoba', 'Granada', 'Valladolid', 'Vigo', 'Gijón', 'San Sebastián'],
    IT: ['Rome', 'Milan', 'Naples', 'Turin', 'Palermo', 'Genoa', 'Bologna', 'Florence', 'Bari', 'Catania', 'Venice', 'Verona', 'Padua', 'Trieste', 'Brescia', 'Parma', 'Modena', 'Pisa'],
    NL: ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven', 'Groningen', 'Tilburg', 'Almere', 'Breda', 'Nijmegen', 'Arnhem', 'Haarlem', 'Maastricht'],
    BE: ['Brussels', 'Antwerp', 'Ghent', 'Charleroi', 'Liège', 'Bruges', 'Namur', 'Leuven', 'Mons'],
    AT: ['Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt'],
    CH: ['Zurich', 'Geneva', 'Basel', 'Bern', 'Lausanne', 'Lucerne', 'St. Gallen', 'Winterthur'],
    PT: ['Lisbon', 'Porto', 'Braga', 'Coimbra', 'Faro', 'Funchal', 'Aveiro', 'Setúbal'],
    SE: ['Stockholm', 'Gothenburg', 'Malmö', 'Uppsala', 'Västerås', 'Örebro', 'Linköping', 'Helsingborg'],
    NO: ['Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen', 'Kristiansand', 'Tromsø'],
    DK: ['Copenhagen', 'Aarhus', 'Odense', 'Aalborg', 'Esbjerg', 'Randers'],
    FI: ['Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku', 'Jyväskylä'],
    PL: ['Warsaw', 'Kraków', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk', 'Szczecin', 'Lublin', 'Katowice'],
    CZ: ['Prague', 'Brno', 'Ostrava', 'Plzeň', 'Liberec', 'Olomouc'],
    GR: ['Athens', 'Thessaloniki', 'Patras', 'Heraklion', 'Larissa', 'Rhodes', 'Chania'],
    JP: ['Tokyo', 'Yokohama', 'Osaka', 'Nagoya', 'Sapporo', 'Fukuoka', 'Kobe', 'Kyoto', 'Hiroshima', 'Sendai', 'Naha'],
    KR: ['Seoul', 'Busan', 'Incheon', 'Daegu', 'Daejeon', 'Gwangju', 'Ulsan', 'Jeju'],
    CN: ['Beijing', 'Shanghai', 'Guangzhou', 'Shenzhen', 'Chengdu', 'Hangzhou', 'Wuhan', 'Xi\'an', 'Nanjing', 'Tianjin', 'Chongqing', 'Suzhou', 'Qingdao'],
    IN: ['Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow', 'Surat', 'Kochi', 'Goa'],
    SG: ['Singapore'],
    MY: ['Kuala Lumpur', 'George Town', 'Johor Bahru', 'Ipoh', 'Shah Alam', 'Petaling Jaya', 'Kota Kinabalu', 'Kuching', 'Malacca'],
    TH: ['Bangkok', 'Chiang Mai', 'Phuket', 'Pattaya', 'Hat Yai', 'Khon Kaen', 'Udon Thani', 'Hua Hin'],
    AE: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah'],
    SA: ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Khobar', 'Tabuk'],
    ZA: ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Port Elizabeth', 'Bloemfontein', 'East London', 'Stellenbosch'],
    MX: ['Mexico City', 'Guadalajara', 'Monterrey', 'Puebla', 'Tijuana', 'León', 'Cancún', 'Mérida', 'Querétaro'],
    BR: ['São Paulo', 'Rio de Janeiro', 'Brasília', 'Salvador', 'Fortaleza', 'Belo Horizonte', 'Manaus', 'Curitiba', 'Recife', 'Porto Alegre'],
    AR: ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata'],
    HK: ['Hong Kong', 'Kowloon', 'Tsuen Wan', 'Sha Tin', 'Tuen Mun'],
    TW: ['Taipei', 'Kaohsiung', 'Taichung', 'Tainan', 'Hsinchu', 'Keelung'],
    IL: ['Jerusalem', 'Tel Aviv', 'Haifa', 'Beersheba', 'Netanya', 'Eilat'],
    TR: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya', 'Adana', 'Gaziantep', 'Konya'],
    RU: ['Moscow', 'Saint Petersburg', 'Novosibirsk', 'Yekaterinburg', 'Kazan', 'Sochi'],
    UA: ['Kyiv', 'Kharkiv', 'Odesa', 'Dnipro', 'Lviv'],
    EG: ['Cairo', 'Alexandria', 'Giza', 'Sharm El Sheikh', 'Luxor', 'Aswan', 'Hurghada'],
    NG: ['Lagos', 'Abuja', 'Kano', 'Ibadan', 'Port Harcourt', 'Benin City'],
    KE: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret']
  };

  var CAPITALS = {
    AF: 'Kabul', AL: 'Tirana', DZ: 'Algiers', AD: 'Andorra la Vella', AO: 'Luanda', AG: "Saint John's",
    AM: 'Yerevan', AZ: 'Baku', BS: 'Nassau', BH: 'Manama', BD: 'Dhaka', BB: 'Bridgetown', BY: 'Minsk',
    BZ: 'Belmopan', BJ: 'Porto-Novo', BM: 'Hamilton', BT: 'Thimphu', BO: 'La Paz', BA: 'Sarajevo',
    BW: 'Gaborone', BN: 'Bandar Seri Begawan', BG: 'Sofia', BF: 'Ouagadougou', BI: 'Gitega', CV: 'Praia',
    KH: 'Phnom Penh', CM: 'Yaoundé', KY: 'George Town', CF: 'Bangui', TD: 'N\'Djamena', CL: 'Santiago',
    CO: 'Bogotá', KM: 'Moroni', CG: 'Brazzaville', CD: 'Kinshasa', CR: 'San José', CI: 'Yamoussoukro',
    HR: 'Zagreb', CU: 'Havana', CY: 'Nicosia', DJ: 'Djibouti', DM: 'Roseau', DO: 'Santo Domingo',
    EC: 'Quito', SV: 'San Salvador', GQ: 'Malabo', ER: 'Asmara', SZ: 'Mbabane', ET: 'Addis Ababa',
    FJ: 'Suva', GA: 'Libreville', GM: 'Banjul', GE: 'Tbilisi', GH: 'Accra', GD: "Saint George's",
    GT: 'Guatemala City', GN: 'Conakry', GW: 'Bissau', GY: 'Georgetown', HT: 'Port-au-Prince',
    HN: 'Tegucigalpa', HU: 'Budapest', IS: 'Reykjavik', ID: 'Jakarta', IR: 'Tehran', IQ: 'Baghdad',
    JM: 'Kingston', JO: 'Amman', KZ: 'Astana', KI: 'Tarawa', KP: 'Pyongyang', KW: 'Kuwait City',
    KG: 'Bishkek', LA: 'Vientiane', LV: 'Riga', LB: 'Beirut', LS: 'Maseru', LR: 'Monrovia', LY: 'Tripoli',
    LI: 'Vaduz', LT: 'Vilnius', LU: 'Luxembourg City', MO: 'Macau', MG: 'Antananarivo', MW: 'Lilongwe',
    MV: 'Malé', ML: 'Bamako', MT: 'Valletta', MH: 'Majuro', MR: 'Nouakchott', MU: 'Port Louis',
    FM: 'Palikir', MD: 'Chișinău', MC: 'Monaco', MN: 'Ulaanbaatar', ME: 'Podgorica', MA: 'Rabat',
    MZ: 'Maputo', MM: 'Naypyidaw', NA: 'Windhoek', NR: 'Yaren', NP: 'Kathmandu', NI: 'Managua',
    NE: 'Niamey', MK: 'Skopje', OM: 'Muscat', PK: 'Islamabad', PW: 'Ngerulmud', PS: 'Ramallah',
    PA: 'Panama City', PG: 'Port Moresby', PY: 'Asunción', PE: 'Lima', PH: 'Manila', QA: 'Doha',
    RO: 'Bucharest', RW: 'Kigali', KN: 'Basseterre', LC: 'Castries', VC: 'Kingstown', WS: 'Apia',
    SM: 'San Marino', ST: 'São Tomé', SN: 'Dakar', RS: 'Belgrade', SC: 'Victoria', SL: 'Freetown',
    SB: 'Honiara', SO: 'Mogadishu', SS: 'Juba', LK: 'Colombo', SD: 'Khartoum', SR: 'Paramaribo',
    SY: 'Damascus', TJ: 'Dushanbe', TZ: 'Dodoma', TL: 'Dili', TG: 'Lomé', TO: 'Nuku\'alofa',
    TT: 'Port of Spain', TN: 'Tunis', TV: 'Funafuti', UG: 'Kampala', UY: 'Montevideo', UZ: 'Tashkent',
    VU: 'Port Vila', VA: 'Vatican City', VE: 'Caracas', VN: 'Hanoi', YE: 'Sana\'a', ZM: 'Lusaka', ZW: 'Harare'
  };

  function countryName(code) {
    var cc = String(code || '').toUpperCase();
    for (var i = 0; i < COUNTRIES.length; i++) {
      if (COUNTRIES[i].c === cc) return COUNTRIES[i].n;
    }
    return cc;
  }

  function statesForCountry(code) {
    return String(code || '').toUpperCase() === 'US' ? US_STATES.slice() : [];
  }

  function citiesForCountry(code) {
    var cc = String(code || '').toUpperCase();
    if (cc === 'US') return [];
    if (CITIES[cc]) return CITIES[cc].slice();
    if (CAPITALS[cc]) return [CAPITALS[cc]];
    return [];
  }

  function citiesForUsState(state) {
    var name = String(state || '').trim();
    if (!name) return [];
    if (US_CITIES_BY_STATE[name]) return US_CITIES_BY_STATE[name].slice();
    return [];
  }

  function normalizeGeoCity(city, region, countryCode) {
    var value = String(city || '').trim();
    if (!value) return String(region || '').trim();

    value = value.replace(/^City of\s+/i, '');
    value = value.replace(/,\s*(England|Scotland|Wales|Northern Ireland|Great Britain|United Kingdom)$/i, '');
    value = value.replace(/,\s*[A-Za-z .'-]+$/i, function (match) {
      var suffix = match.replace(/^,\s*/, '').trim();
      if (region && suffix.toLowerCase() === String(region).toLowerCase()) return '';
      if (countryCode === 'GB' && /^(England|Scotland|Wales|Northern Ireland)$/i.test(suffix)) return '';
      return match;
    });

    return value.trim();
  }

  function matchOptionValue(options, query) {
    if (!query || !options || !options.length) return '';
    var q = String(query).toLowerCase().trim();
    var i;
    for (i = 0; i < options.length; i++) {
      if (String(options[i]).toLowerCase() === q) return options[i];
    }
    for (i = 0; i < options.length; i++) {
      var opt = String(options[i]).toLowerCase();
      if (opt.indexOf(q) !== -1 || q.indexOf(opt) !== -1) return options[i];
    }
    return '';
  }

  window.GOHUB_CONTACT_LOCATION = {
    countries: COUNTRIES,
    usStates: US_STATES,
    usCitiesByState: US_CITIES_BY_STATE,
    cities: CITIES,
    capitals: CAPITALS,
    countryName: countryName,
    statesForCountry: statesForCountry,
    citiesForCountry: citiesForCountry,
    citiesForUsState: citiesForUsState,
    normalizeGeoCity: normalizeGeoCity,
    matchOptionValue: matchOptionValue,
    flagUrl: function (code) {
      var cc = String(code || '').toLowerCase();
      if (!/^[a-z]{2}$/.test(cc)) return '';
      return 'https://flagcdn.com/w40/' + cc + '.png';
    }
  };
})();
